<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Order">
                    <v-date-picker
                      mode="range"
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Order', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export data Order</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "order_non_related_to_spkb",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      loading: false,
      myDate: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.myDate === null) {
          alert("Tanggal Harus di pilih");
        } else {
          let start = moment(this.myDate.start).format("YYYY-MM-DD");
          let end = moment(this.myDate.end).format("YYYY-MM-DD");
          this.loading = true;
          this.axios({
            url: "web/export/order/not-related-to-spkb/" + start + "/" + end + "/",
            method: "GET",
            responseType: "arraybuffer" //before "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "order_history.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
          //window.location.href = axios.defaults.baseURL+'web/export/data-attendance/'+this.currentMonth+'/'+this.currentYear+'/';
          //window.location.href = axios.defaults.baseURL+'web/export/data-order-history/'+start+'/'+end+'/';
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
